<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>店铺信息</span>
        <div>
          <el-button size="small" @click="_queryShopMethod()">刷新</el-button>
          <el-button type="primary" size="small" @click="_openAddShopModal()">
            <i class="el-icon-plus"></i>开店
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="shopInfo.shops" style="width: 100%" border stripe size="small">
          <el-table-column prop="shopLogo" label="店铺logo" align="center">
            <template slot-scope="scope">
              <img v-if="scope.row.shopLogo" :src="scope.row.shopLogo"
                style="width: 60px; height: 60px; border-radius: 5px;">
              <img v-else src="/img/noPhoto.jpg" style="width: 60px; height: 60px; border-radius: 5px;">
            </template>
          </el-table-column>
          <el-table-column prop="areaName" label="店铺区域" align="center"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.shopName }}({{ scope.row.shopTypeName }})
            </template>
          </el-table-column>
          <el-table-column prop="shopId" label="店铺编号" align="center"></el-table-column>
          <el-table-column prop="openType" label="开店类型" align="center">
            <template slot-scope="scope">
              {{ shopInfo.openTypeName[scope.row.openType] }}
            </template>
          </el-table-column>
          <el-table-column prop="shopDesc" label="店铺描述" align="center"></el-table-column>
          <el-table-column prop="returnPerson" label="退货联系人" align="center"></el-table-column>
          <el-table-column prop="returnLink" label="退货电话" align="center"></el-table-column>
          <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_openEditShopModel(scope.row)">修改</el-button>
                <el-button size="mini" v-if="scope.row.state == '004'" @click="_payFee(scope.row.shopId)">
                  缴保证金
                </el-button>
                <el-button size="mini" @click="_openShopQrCode(scope.row)">二维码</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopInfo.conditions.page"
          :page-size="DEFAULT_ROWS" layout="total, prev, pager, next" :total="shopInfo.total"
          style="margin-top: 20px;"></el-pagination>
      </div>
    </el-card>

    <add-shop ref="addShop" @listShop="_queryShopMethod"></add-shop>
    <edit-shop ref="editShop" @listShop="_queryShopMethod"></edit-shop>
    <view-qr-code ref="viewQrCode" @listShop="_queryShopMethod"></view-qr-code>
  </div>
</template>

<script>
import { getShopList, getShopTypes } from '@/api/shop/shopApi'
//import { getDict } from '@/api/shop/shopApi'
import AddShop from '@/components/shop/addShop'
import EditShop from '@/components/shop/editShop'
import viewQrCode from '@/components/system/viewQrcode'

export default {
  components: {
    AddShop,
    EditShop,
    viewQrCode
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      shopInfo: {
        openTypeName: ["", "商家", "服务", "商家和服务"],
        shops: [],
        total: 0,
        records: 1,
        moreCondition: false,
        shopId: '',
        codeUrl: '',
        shopTypes: [],
        conditions: {
          ruleId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    this._listShopTypes(1, 50)
    console.log(this.shopInfo.moreCondition)
  },
  methods: {
    async _listShopTypes(page, rows) {
      try {
        const res = await getShopTypes({ page, row: rows })
        this.shopInfo.shopTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _listShops(page, rows) {
      this.shopInfo.conditions.page = page
      this.shopInfo.conditions.row = rows
      try {
        const res = await getShopList(this.shopInfo.conditions)
        this.shopInfo.total = res.total
        this.shopInfo.records = res.records
        this.shopInfo.shops = res.data
      } catch (error) {
        console.error(error)
      }
    },
    _openAddShopModal() {
      this.$refs.addShop.open()
    },
    _openEditShopModel(shop) {
      this.$refs.editShop.open(shop)
    },
    _queryShopMethod() {
      this._listShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listShops(val, this.DEFAULT_ROWS)
    },
    async _payFee(shopId) {
      try {
        const res = await this.$api.post('/payment/toQrBondFeePay', { shopId })
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$refs.viewQrCode.open({
          title: '扫码缴保证金',
          url: res.data.qrCode,
          remark: res.data.remark,
        })
      } catch (error) {
        console.error(error)
      }
    },
    _openShopQrCode(shop) {
      this.$refs.viewQrCode.open({
        qrcodeName: shop.shopName + "二维码",
        qrCodeUrl: shop.phoneIndexUrl,
        remark: '手机扫码查看店铺',
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
}
</style>